export default "<p>\n  modal-qrcode works!\n</p>\n";